import React from "react";
import loadable from "@loadable/component";
import {getContractorData} from "../../actions/contractor";

export default {
	component: loadable(() => import(/* webpackChunkName: "ContractorListing" */ "./ContractListing"),{
		fallback: <div>Loading...</div>
	}),
	clientData: store => {
		let state = store.getState();
		let {loggedUser = {}} = state.session.user;
		const isContractorV3 = (loggedUser?.subType == 'CONTRACTORV3');
		let status = "pending";
		if(isContractorV3){
			status = "permissionpending";
		}
		return getContractorData({
			pageNo: 1,
			status: status,
			mobileNo: loggedUser.userName
		})(store.dispatch);
	}
};